<div class="flex-grow-1 d-flex flex-row p-1" *ngIf="isExistingPlayer">
  <div class="m-1">
    <div class=" player-initials rounded-circle color-gray-bg white avatar d-flex justify-content-center flex-shrink-0">
      <div class="align-self-center white">
        {{userName | initials}}
      </div>
    </div>
  </div>
  <div class="d-flex flex-grow-1 flex-column ml-2 font-weight-bold">
    <div class="flex-grow-1">{{userName}}</div>
    <div class="flex-grow-1">ID: {{player.memberId}}</div>
  </div>
</div>

<div class="flex-grow-1 d-flex flex-row p-1" *ngIf="isAddedPlayer">
  <div class="d-flex flex-grow-1 flex-column ml-2 player-added-text">
    {{player.eMail}}
  </div>
</div>

<div class="flex-grow-1 d-flex flex-row p-1" *ngIf="!player">
  <div class="m-1">
    <div
      class=" player-initials rounded-circle color-light-gray-bg white avatar d-flex justify-content-center flex-shrink-0">
    </div>
  </div>
  <div class="d-flex flex-grow-1 flex-column ml-2 font-weight-bold">
    <div class="flex-grow-1">
      <p class="color-light-gray-bg player-empty-name"></p>
    </div>
    <div class="flex-grow-1">
      <p class="color-light-gray-bg player-empty-id"></p>
    </div>
  </div>
</div>
